import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Modal, Table } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Footer from "../../../components/Footer";
import NavBar from "../../../components/NavBar";
import SideBar from "../../../components/SideBar";
import { API_URL, TOKEN } from "../../../variables/constants";
import AddEntiteConstat from "./AddEntiteConstat";
import ActionDropdown from "../../production/components/ActionDropdown";

const EntiteConstats = () => {
  const [entites, setEntites] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedEntite, setSelected] = useState(null);

  useEffect(() => {
    loadEntites();
  }, []);

  const loadEntites = () =>
    axios
      .get(`${API_URL}/api/entite-constat`, {
        headers: { Authorization: `Bearer ${TOKEN}` },
      })
      .then(({ data }) => {
        const sorted = data.sort((a, b) => b.entiteConstatId - a.entiteConstatId);
        setEntites(sorted);
      })
      .catch((err) => console.error("Erreur chargement entités :", err));

  const handleShow = (edit = false, entite = null) => {
    setEditMode(edit);
    setSelected(entite);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setEditMode(false);
    setSelected(null);
  };

  const handleAdd = (newEntite) => {
    setEntites((prev) => [newEntite, ...prev]);
  };

  const handleUpdate = (updatedEntite) => {
    setEntites((prev) =>
      prev.map((e) =>
        e.entiteConstatId === updatedEntite.entiteConstatId ? updatedEntite : e
      )
    );
  };

  const handleDeleteEntite = (id) => {
    Modal.confirm({
      title: "Êtes-vous sûr de vouloir supprimer cette entité ?",
      okText: "Oui",
      okType: "danger",
      cancelText: "Annuler",
      onOk: () =>
        axios
          .delete(`${API_URL}/api/entite-constat/${id}`, {
            headers: { Authorization: `Bearer ${TOKEN}` },
          })
          .then(() => {
            setEntites((prev) => prev.filter((e) => e.entiteConstatId !== id));
            toast.success("Entité supprimée avec succès.");
          })
          .catch((err) => {
            console.error("Erreur suppression :", err);
            toast.error("Erreur lors de la suppression de l'entité.");
          }),
    });
  };

  const columns = [
    { title: "Nom", dataIndex: "nom" },
    { title: "Adresse", dataIndex: "adresse" },
    {
      title: "Contacts",
      render: (_, r) =>
        [r.telephone1, r.telephone2, ...(r.contact || [])]
          .filter(Boolean)
          .join(" / ") || "—",
    },
    {
      title: "Actions",
      render: (_, r) => (
        <div className="d-flex gap-2">
          <ActionDropdown
            actions={[
              {
                key: "edit",
                label: "Modifier",
                icon: <i className="bx bx-edit-alt" />,
                onClick: () => handleShow(true, r),
              },
              {
                key: "delete",
                label: "Supprimer",
                icon: <i className="bx bx-trash" />,
                danger: true,
                onClick: () => handleDeleteEntite(r.entiteConstatId),
              },
            ]}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <SideBar currentMenu="PARAMETRES_SINISTRES" />
        <div className="layout-page">
          <NavBar />
          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                style={{ marginBottom: 16 }}
                onClick={() => handleShow()}
              >
                Ajouter une entité de constat
              </Button>

              <div className="card">
                <Table
                  columns={columns}
                  dataSource={entites}
                  rowKey="entiteConstatId"
                  pagination={{ showSizeChanger: true }}
                />
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>

      {showModal && (
        <AddEntiteConstat
          show={showModal}
          handleClose={handleClose}
          editMode={editMode}
          selectedEntite={selectedEntite}
          entites={entites}
          onAdd={handleAdd}
          onUpdate={handleUpdate}
        />
      )}
    </div>
  );
};

export default EntiteConstats;
